import { setServerGlobals } from "./server/setServerGlobals";
import { setupBuildInfo } from "./server/setupBuildOptions";
import { createWorkerHandler } from "./server/workerHandler";
import { ensureExists } from "./utils/ensureExists";
import { getFetchStaticHtml, setFetchStaticHtml } from "./server/staticHtmlFetcher";
import { withRange } from "./server/assetRange";
async function serve(buildInfo, lazyRoutes, serveOptions) {
  setupBuildInfo(buildInfo);
  ensureExists(buildInfo.oneOptions);
  setServerGlobals();
  var handler = createWorkerHandler({
    oneOptions: buildInfo.oneOptions,
    buildInfo,
    lazyRoutes,
    disableModuleCache: serveOptions === null || serveOptions === void 0 ? void 0 : serveOptions.disableModuleCache
  });
  return {
    fetch: handler.handleRequest,
    updateRoutes(newBuildInfo, newLazyRoutes) {
      setupBuildInfo(newBuildInfo);
      handler.updateRoutes(newBuildInfo, newLazyRoutes);
    }
  };
}
export {
  getFetchStaticHtml,
  serve,
  setFetchStaticHtml,
  withRange
};
//# sourceMappingURL=serve-worker.js.map
